import React from 'react'

const Forbidden: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-body">
        <div className="container">
          <h1 className="title">No access</h1>
          <h2 className="subtitle">You do not have access to that page</h2>
        </div>
      </div>
    </section>
  )
}

export default Forbidden
